// Event catalog for the shared dataLayer tracking module.
// Inspired by the Renault Group GTM Tracking Wizard, but not a literal port:
// GA4's own ecommerce event names are kept as-is (GA4 recognizes them natively),
// everything else uses plain snake_case instead of the Wizard's legacy camelCase -
// snake_case is the standard for every event name in this catalog, no exceptions.

// Page / session
// Page View itself has no 'event' key in the Wizard convention - see
// utils/tracking/index.js#pushRaw - so there is no constant for it here.
export const VIRTUAL_PAGEVIEW = 'virtual_pageview';

// Configurator flow
export const CONFIGURATOR_START = 'configurator_start';
export const CONFIGURATOR_STEP = 'configurator_step';
export const CONFIGURATOR_COMPLETE = 'configurator_complete';

// Forms / leads
export const FORM_OPEN = 'form_open';
export const FORM_STEP = 'form_step';
export const FORM_SUBMIT = 'form_submit';

// Other business events from the Wizard catalog - declared for anyone who
// needs them, wired up only where this app actually has a matching UI action.
export const BROCHURE_DOWNLOAD = 'brochure_download';
export const DEALER_SEARCH = 'dealer_search';
export const OFFER_VIEW = 'offer_view';
export const FINANCE_INTERACTION = 'finance_interaction';

// GA4 ecommerce (standard GA4 event names, not renamed)
export const VIEW_ITEM = 'view_item';
export const SELECT_ITEM = 'select_item';
export const ADD_TO_CART = 'add_to_cart';
export const REMOVE_FROM_CART = 'remove_from_cart';
export const BEGIN_CHECKOUT = 'begin_checkout';
export const PURCHASE = 'purchase';
